/* eslint-disable no-console */
import { IModule } from "angular";
import { Trace } from "@uirouter/angularjs";

/* the new way provided by the Router service to trace the routes */
export function enableRouteTracing(app: IModule): void {
  // Trace only Transition + View Config
  // full list of options here : https://ui-router.github.io/ng1/docs/1.0.0-rc.1/enums/trace.category.html
  app.run(["$trace", ($trace: Trace) => $trace.enable(1, 5)]);
}
